<div id="dialog-container">
  <h2 mat-dialog-title>Actions on selected writeoffs</h2>
  <mat-dialog-actions id="dialog-body">
    <button mat-raised-button color="warn" [mat-dialog-close]="false">Deny</button>
    <button mat-raised-button color="success" [mat-dialog-close]="true">Approve</button>
  </mat-dialog-actions>
</div>